import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCog,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import {
  Nav,
  Navbar,
  Dropdown,
  Container,
  Button,
} from "react-bootstrap";

import { Routes } from "../../routes";
import { parsedUser } from "../../common/GetCurrentUser";

const TopNavbar = (props) => {
  const user = parsedUser();
  const userEmail = user && (user.Email || user.email);

  return (
    <Navbar className="app-navbar border-bottom bg-white sticky-top">
      <Container fluid className="px-3 px-lg-4">
        <div className="d-flex align-items-center justify-content-between w-100">
          <Button
            type="button"
            variant="light"
            className="sidebar-toggle d-inline-flex align-items-center gap-2"
            aria-controls="main-sidebar"
            aria-expanded={props.isSidebarOpen}
            aria-label={props.isSidebarOpen ? "Cerrar menú" : "Abrir menú"}
            onClick={props.onToggleSidebar}
          >
            <FontAwesomeIcon icon={faBars} />
            <span className="d-none d-sm-inline">Menú</span>
          </Button>

          <Nav className="align-items-center">
            <Dropdown as={Nav.Item} align="end">
              <Dropdown.Toggle
                as={Nav.Link}
                className="user-menu-toggle d-flex align-items-center text-dark px-2"
              >
                <FontAwesomeIcon icon={faUserCircle} className="user-menu-icon" />
                <span className="ms-2 d-none d-sm-inline text-truncate">
                  {userEmail}
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown mt-2">
                <Dropdown.Item
                  className="fw-bold"
                  onClick={() => props.history.push(Routes.Profile.path)}
                >
                  <FontAwesomeIcon icon={faUserCircle} className="me-2" />
                  Perfil
                </Dropdown.Item>
                <Dropdown.Item
                  className="fw-bold"
                  onClick={() => props.history.push(Routes.Settings.path)}
                >
                  <FontAwesomeIcon icon={faCog} className="me-2" />
                  Configuración
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  className="fw-bold"
                  onClick={() => props.history.push(Routes.SignIn.path)}
                >
                  <FontAwesomeIcon
                    icon={faSignOutAlt}
                    className="text-danger me-2"
                  />
                  Cerrar Sesión
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};

export default TopNavbar;
